import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { RequestStripePayoutsInterface } from '../../../interface/stripe-payouts.interface';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { setNotificationMessage } from '../../../redux/slices/NotificationManagementSlice';
import {
  fetchUnapprovedPendingCount,
  fetchUnapprovedStripePayouts,
} from '../../../redux/slices/UnapprovedStripePayoutsSlice';
import MyButton from '../../../shared-components/button/Button';
import SuccessNotification from '../../../shared-components/success-notification/SuccessNotification';
import stripePayoutsApi from '../../../utils/api/stripe-payouts';

interface ModalBoxDetail {
  title: string;
  content: JSX.Element;
  notificationModal: boolean;
  rightCorner: string;
}

/**
 * Reject content component
 * @param {any} param0 - The param0
 * @param {any} param0.id - The id prop
 * @param {any} param0.setModalBoxStatus - The setModalBoxStatus prop
 * @param {any} param0.setModalBoxDetail - The setModalBoxDetail prop
 * @returns {any} The result
 */
function RejectedContext({
  id,
  setModalBoxStatus,
  setModalBoxDetail,
}: {
  id: string;
  setModalBoxStatus: Dispatch<SetStateAction<'open' | 'close'>>;
  setModalBoxDetail: Dispatch<SetStateAction<ModalBoxDetail>>;
}) {
  const { t } = useTranslation('stripePayout');
  const dispatch = useAppDispatch();
  const [buttonStatus, setButtonStatus] = useState(false);
  const { limit, page, loading } = useAppSelector((state) => state.unapprovedStripePayouts);

  /**
   * Handle the fetch the data in api function
   * @param {any} data - The data
   */
  const fetchData = (data: RequestStripePayoutsInterface) => {
    if (!loading) {
      dispatch(fetchUnapprovedStripePayouts(data));
    }
  };
  /**
   * Function for handling payouts Reject
   */
  const handleRejectPayment = async () => {
    try {
      setButtonStatus(true);
      await stripePayoutsApi.rejectStripePayouts(id);
      fetchData({ page, limit });
      dispatch(fetchUnapprovedPendingCount());
      setModalBoxDetail({
        title: '',
        content: (
          <SuccessNotification
            title={t('stripePaymentRejectedSuccessfully')}
            description=""
            notificationCloseTimer={3000}
            onNotificationClose={() => {
              setModalBoxStatus('close');
              setButtonStatus(false);
            }}
          />
        ),
        rightCorner: '',
        notificationModal: true,
      });

      setModalBoxStatus('open');
    } catch (error: any) {
      setButtonStatus(false);
      dispatch(
        setNotificationMessage({
          message: error?.response?.data?.message || 'Something went wrong!',
          status: true,
          type: 'error',
          code: error?.response?.data?.code,
        }),
      );
    }
  };

  return (
    <div className="content-warp">
      <div className="content">
        <h1 className="reject">{t('rejectPayoutTitle')}</h1>
        <p>
          <span>{t('warningLabel')} </span>
          <span>{t('rejectPayoutMessage')}</span>
        </p>
      </div>
      <div className="content-button">
        <MyButton
          label={t('cancel')}
          buttonType="primary-outline"
          onClickFunc={() => setModalBoxStatus('close')}
          disableButton={buttonStatus}
        />
        <MyButton
          label={t('reject')}
          buttonType="error"
          onClickFunc={() => handleRejectPayment()}
          loading={buttonStatus}
        />
      </div>
    </div>
  );
}

export default RejectedContext;
